export const skills = [
    // Frontend
    "React.js",
    "React Query (TanStack Query)",
    "Zustand",
    "Tailwind CSS",
    "Styled Components",
    "Working with API",
    "TypeScript",

    // Tooling
    "Render",
    "Fly.io",
    "Vercel",
    "CI/CD (GitHub Actions)",
    "Docker",

    // Backend (Natours)
    "Node.js",
    "Express",
    "MongoDB & Mongoose",
    "Authentication & Authorization",
    "Json Web Token",
    "Security best practices",
    "MVC architecture",
    "Stripe payments",
    "Image upload & processing",
    "Email sending (SendGrid)",
    "REST API design",
    "Map rendering & markers",
    "Client-side state persistence",

    // Testing
    "Jest",
    "React Testing Library",
    "Cypress",

    // Design
    "TeamWork",
    "Figma",
];


export const nextSkills = [
    "TypeScript (advanced)",
    "Next.js 14 (App Router, Server Components)",
    "Prisma",
    "PostgreSQL",
    "Redis",
    "WebSockets / real-time apps",
    "GraphQL",
    "Design Systems (Storybook, Radix UI)",
    "Framer Motion (advanced)",
    "AI-powered front-end workflows",
    "Testing on production level (integration, e2e pipelines)",
    "Turborepo / monorepo patterns",
];


